<template>
  <div>
    <transition name="slide-in">
      <ModalControl title="Centered Modal" :is_visible="is_modal_open">
        <div v-if="this.is_inputting_old_pin">
          <div class="flex flex-row items-center justify-between">
            <LabelControl :content="$t('mip017')" />
            <IconControl
              @click="this.closeEditModal()"
              id="exit-black"
              :width="50"
              :height="50"
            />
          </div>
          <KeypadControl
            ref="OldPINKeypad"
            input_type="PIN"
            @digits-full="savePIN"
          />
          <div
            class="flex w-full justify-center align-center text-center"
            style="margin-top: -2rem"
          >
            <div class="pin-btn" style="width: 37rem">
              <ButtonControl
                @click="submitPIN()"
                :disabled="!isPINValid"
                :button_loading="this.loading"
                class="w-full"
                :text="$t('btn002')"
              />
            </div>
          </div>
        </div>
        <div v-else-if="this.is_inputting_new_pin">
          <div class="flex flex-row items-center justify-between">
            <LabelControl v-if="this.is_editing_pin" :content="$t('mip018')" />
            <LabelControl v-else :content="$t('mip020')" />
            <IconControl
              @click="this.closeEditModal()"
              id="exit-black"
              :width="50"
              :height="50"
            />
          </div>
          <p v-if="!this.is_editing_pin" class="text-3xl mt-5">
            {{ $t("mip022") }}
          </p>
          <KeypadControl
            ref="NewPINKeypad"
            input_type="PIN"
            @digits-full="savePIN"
          />
          <div
            class="flex w-full justify-center align-center text-center"
            style="margin-top: -2rem"
          >
            <div class="pin-btn" style="width: 37rem">
              <ButtonControl
                @click="submitPIN()"
                :disabled="!isPINValid"
                :button_loading="this.loading"
                class="w-full"
                :text="$t('btn002')"
              />
            </div>
          </div>
        </div>
        <div v-else-if="this.is_inputting_confirm_pin">
          <div class="flex flex-row items-center justify-between">
            <LabelControl v-if="this.is_editing_pin" :content="$t('mip019')" />
            <LabelControl v-else :content="$t('mip021')" />
            <IconControl
              @click="this.closeEditModal()"
              id="exit-black"
              :width="50"
              :height="50"
            />
          </div>
          <KeypadControl
            ref="ConfirmPINKeypad"
            input_type="PIN"
            @digits-full="savePIN"
          />
          <div
            class="flex w-full justify-center align-center text-center"
            style="margin-top: -2rem"
          >
            <div class="pin-btn" style="width: 37rem">
              <ButtonControl
                @click="submitPIN()"
                :disabled="!isPINValid"
                :button_loading="this.loading"
                class="w-full"
                :text="$t('btn002')"
              />
            </div>
          </div>
        </div>
      </ModalControl>
    </transition>

    <transition name="slide-in">
      <transition name="slide-in">
        <ModalControl v-if="toggle_message" :is_visible="toggle_message">
          <div
            class="flex flex-col justify-center align-center items-center p-8"
          >
            <img :src="getIcon('check')" class="mb-10" />
            <LabelControl
              type="heading"
              class="text-grey-darkest font-bold text-5xl mb-8 text-center"
              :content="$t('mip016')"
            />
            <div
              class="flex w-full text-center justify-center align-center items-center"
            >
              <ButtonControl
                :text="$t('btn014')"
                theme="success"
                @click="toggleMessage"
              />
            </div>
          </div>
        </ModalControl>
      </transition>
    </transition>
  </div>
</template>
<script>
import ModalControl from "./ModalControl.vue";
import LabelControl from "./LabelControl.vue";
import IconControl from "./IconControl.vue";
import KeypadControl from "./KeypadControl.vue";
import ButtonControl from "./ButtonControl.vue";
import mixin from "@/mixins/controls.js";
import user from "@/services/user";

export default {
  name: "v-pin-modal",
  mixins: [mixin],
  inject: ["setLoading", "setError"],
  components: {
    ModalControl,
    LabelControl,
    IconControl,
    KeypadControl,
    ButtonControl,
  },
  props: {
    is_editing_pin: {
      type: Boolean,
      default: true,
    },
    is_editing_temp: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      toggle_message: false,
      is_modal_open: false,
      is_inputting_old_pin: this.is_editing_pin && !this.is_editing_temp,
      is_inputting_new_pin: this.is_editing_temp,
      is_inputting_confirm_pin: false,
      old_pin: "",
      new_pin: "",
      confirm_pin: "",
      qr: this.$store.state.user.qr,
      uuid: this.$store.state.user.uuid,
      hash: this.$store.state.user.hash,
      loading: false,
      enrollee_name: "",
      enrollee_mobile: "",
      enrollee_email: "",
      enrollee_uuid: "",
      enrollee_hash: "",
      enrollee_account: "",
      enrollee_account_type: "",
    };
  },
  mounted() {
    const enrollee = this.$store.state.pin_enrollment;
    this.enrollee_mobile = enrollee.mobile;
    this.enrollee_email = enrollee.email;
    this.enrollee_name = enrollee.name;
    this.enrollee_uuid = enrollee.uuid;
    this.enrollee_hash = enrollee.hash;
    this.enrollee_account = enrollee.account;
    this.enrollee_account_type = enrollee.account_type;
  },
  watch: {
    val(value) {
      this.$emit("ontyping", {
        name: this.name,
        value: value,
      });
    },
  },
  computed: {
    isPINValid() {
      if (this.is_inputting_old_pin) {
        return this.old_pin.length == 6;
      } else if (this.is_inputting_new_pin) {
        return this.new_pin.length == 6;
      } else if (this.is_inputting_confirm_pin) {
        return this.confirm_pin.length == 6;
      } else {
        return false;
      }
    },
  },
  methods: {
    clearOldPINKeypad() {
      this.$refs.OldPINKeypad.clearDigits();
    },
    clearNewPINKeypad() {
      this.$refs.NewPINKeypad.clearDigits();
    },
    clearConfirmPINKeypad() {
      this.$refs.ConfirmPINKeypad.clearDigits();
    },
    toggleMessage() {
      this.toggle_message = false;
      // if(this.is_editing_temp){
      //   this.$router.push({ name: 'services-page' });
      //   this.showSuccess('PIN update successful!');
      // }
    },
    typing(object) {
      this[object.name] = object.value;
    },
    openEditModal() {
      this.is_modal_open = true;
    },
    closeEditModal() {
      this.is_modal_open = false;
      this.old_pin = "";
      this.new_pin = "";
      this.confirm_pin = "";
      this.is_inputting_old_pin = this.is_editing_pin && !this.is_editing_temp;
      this.is_inputting_new_pin = this.is_editing_temp;
      this.is_inputting_confirm_pin = false;
    },
    savePIN(pin) {
      if (this.is_inputting_old_pin) {
        this.old_pin = pin.join("");
      } else if (this.is_inputting_new_pin) {
        this.new_pin = pin.join("");
      } else if (this.is_inputting_confirm_pin) {
        this.confirm_pin = pin.join("");
      }
    },
    submitPIN() {
      if (this.is_inputting_old_pin) {
        this.loading = true;
        user
          .validateOldPIN(this.hash, this.uuid, this.old_pin)
          .then(() => {
            this.is_inputting_old_pin = false;
            this.is_inputting_new_pin = true;
            this.loading = false;
          })
          .catch((error) => {
            // this.showError("Incorrect PIN. Please try again.");
            this.showError(error.response.data.message);
            this.clearOldPINKeypad();
            this.loading = false;
          });
      } else if (this.is_inputting_new_pin) {
        if (this.old_pin == this.new_pin) {
          this.showError(
            "New PIN is the same as the old PIN. Please try again."
          );
          this.new_pin = "";
          this.clearNewPINKeypad();
          this.is_inputting_new_pin = true;
          this.is_inputting_confirm_pin = false;
          return;
        } else if (
          /^(\d)\1+$/.test(this.new_pin) || // if all digits are the same
          "0123456789".includes(this.new_pin) || // ascending sequence
          "9876543210".includes(this.new_pin) // descending sequence
        ) {
          this.showError("PIN is too simple. Please choose a more secure PIN.");
          this.new_pin = "";
          this.clearNewPINKeypad();
          this.is_inputting_new_pin = true;
          this.is_inputting_confirm_pin = false;
          return;
        }
        this.is_inputting_new_pin = false;
        this.is_inputting_confirm_pin = true;
      } else if (this.is_inputting_confirm_pin) {
        if (this.new_pin != this.confirm_pin) {
          this.showError("PINs do not match. Please try again.");
          this.new_pin = "";
          this.confirm_pin = "";
          this.clearConfirmPINKeypad();
          this.is_inputting_new_pin = true;
          this.is_inputting_confirm_pin = false;
          return;
        }
        this.loading = true;
        if (this.is_editing_pin) {
          if(this.is_editing_temp) {
            this.old_pin = this.$store.state.user.old_pin;
          }
          user
            .editPIN(this.hash, this.uuid, this.old_pin, this.new_pin)
            .then(() => {
              this.closeEditModal();
              // this.toggle_message = true;
              if(this.is_editing_temp) {
                this.$router.push({ name: "services-page" });
              }
              this.showSuccess("PIN successfully updated");
              this.loading = false;
            })
            .catch((error) => {
              this.showError(error.response.data.message);
              this.loading = false;
            });
        } else {
          user
            .enrollPIN(
              this.enrollee_hash,
              this.enrollee_uuid,
              this.$store.state.pin_enrollment.otp_token,
              this.$store.state.pin_enrollment.otp_pin,
              this.enrollee_account,
              this.new_pin,
              this.enrollee_account_type
            )
            .then((response) => {
              if (
                this.enrollee_account_type == 3 ||
                this.enrollee_account_type == 4
              ) {
                user
                  .createSessionAccount(
                    response.data.data.hash,
                    this.enrollee_account,
                    this.enrollee_account_type
                  )
                  .then((response) => {
                    this.saveUserData(response.data.data);
                    this.$router.push({ name: "services-page" }).then(() => {
                      this.closeEditModal();
                      this.showSuccess("Login successful!");
                      this.loading = false;
                    });
                  })
                  .catch((error) => {
                    this.showError(error.response.data.message);
                    this.loading = false;
                  });
              } else if (this.enrollee_account_type == 2) {
                user
                  .createSessionQR(
                    response.data.data.hash,
                    this.enrollee_account,
                    this.enrollee_account_type
                  )
                  .then((response) => {
                    this.saveUserData(response.data.data);
                    this.$router.push({ name: "services-page" }).then(() => {
                      this.closeEditModal();
                      this.showSuccess("Login successful!");
                      this.loading = false;
                    });
                  })
                  .catch((error) => {
                    this.showError(error.response.data.message);
                    this.loading = false;
                  });
              }
            })
            .catch((error) => {
              this.showError(error.response.data.message);
              this.loading = false;
            });
        }
      }
    },
  },
};
</script>

<style scoped>
@media (min-width: 2500px) {
  .pin-btn {
    width: 60rem !important;
    margin-top: -2rem !important;
  }
}
</style>
